import { Close, Timeline } from '@mui/icons-material';
import { Badge, Box, IconButton, Tooltip } from '@mui/material';
import { getRequestEvaluations } from 'lib/api/decisionEngine';
import { cellFormat } from 'lib/designSystem/Table/cellFormat';
import { EvaluationListDialog } from 'lib/common/EvaluationDetails';
import { Evaluation } from 'lib/types/models';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

const TopHeader = ({
  selectedRequest,
  setOpenCloseModal,
}: {
  selectedRequest: any;
  setOpenCloseModal: (open: boolean) => void;
}) => {
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);

  const { data } = getRequestEvaluations(dispatch, {
    requestId: selectedRequest?.firstQuote?.id ?? null,
    requestType: 'factoring-request',
  });

  const evaluations: Evaluation[] = (data?.default ?? []) as Evaluation[];

  if (selectedRequest?.status === 'Creando') {
    return (
      <IconButton aria-label="close" onClick={() => setOpenCloseModal(true)}>
        <Close />
      </IconButton>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Tooltip title="Acceso rápido a la última evaluación">
        <Badge
          badgeContent={evaluations.length}
          color="primary"
          overlap="circular"
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <IconButton onClick={() => setDialogOpen(true)}>
            <Timeline fontSize="medium" />
          </IconButton>
        </Badge>
      </Tooltip>
      {cellFormat(selectedRequest?.status || 'Nuevo', 'status-chip')}
      {evaluations.length > 0 && (
        <EvaluationListDialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          evaluations={evaluations}
        />
      )}
    </Box>
  );
};

export default TopHeader;
